<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<div class="container-fluid">
<div class="upload_row_title">Package Upload</div>
<div>
  <button class="btn btn-dark" (click)="downloadRackCodesTemplate()">
    <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;
    Download Template
  </button>
</div>
<br>
<div class="text-center">
  <input class="form-control" type="file" 
          (change)="onChange($event)" #packageUpload>

          <label  class="packageUpload" (click)="upload()">
            <i class="fa fa-upload" aria-hidden="true"></i>
            Upload</label>
          <label class="cancelUploadPack" (click)="onCancel()">Cancel</label> 
</div>

<div>{{'RECOMMENDED_TO_UPLOAD_FILE' | translate}} </div>

<div class="recentupload_row_title">Recently Uploaded Files Details</div>

<div class="upload_margins">
  <table  class="table table-bordered table-hover">
    <thead style="background: lightgrey;">
      <tr>
        <th scope="col">Sl. No.</th>
        <th scope="col">File Name</th>
        <th scope="col">Uploaded By</th>
        <th scope="col">Uploaded Date</th>
        <th scope="col">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of tableDataSource; let i=index">
        <td>{{i+1}}</td>
        <td>
          <a href="{{item.uri+saas_uri}}">{{item.fileName}}</a>
        </td>
        <td>{{item.uploadedBy}}</td>
        <td>{{item.uploadedDate}}</td>
        <td>{{getStatus(item.status)}}</td>
      </tr>
    </tbody>
  </table>
</div>
</div>
